import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import { useEffect } from 'react';
import { useObjectMemo } from '@hon2a/use-object-memo';
/**
 * Loads Segment as soon as `appId` is provided (if it's not already loaded).
 * @param appId
 * @param segmentOptions (optional)
 *
 * @note Segment can only be loaded once, so changes to `segmentOptions` will be ignored.
 */

export var useSegment = function useSegment(appId, segmentOptions) {
  useEffect(function () {
    if (appId && !analytics.initialize) {
      analytics.load(appId, segmentOptions);
      analytics.page();
    }
  }, [appId]);
};
/**
 * Identifies user to Segment.
 * @param username
 * @param traits (optional)
 * @param options (optional) `analytics.identify` options (note that changes are _not_ observed)
 */

export var useSegmentIdentity = function useSegmentIdentity(username, traits, options) {
  var traitsMemo = useObjectMemo(traits);
  useEffect(function () {
    if (username) analytics.identify(username, traitsMemo, options);else if (traitsMemo) analytics.identify(traitsMemo, options);
  }, [username, traitsMemo]);
};
/**
 * Notifies Segment about entering a distinct "page".
 * @param name
 * @param properties (optional) page properties
 *   @param properties.category - page category
 * @param options (optional) `analytics.page` options
 *
 * @note Non-empty name must be provided for the notification to be sent.
 * @note Changes to `properties` and `options` will be ignored, only change to `name` will trigger update.
 */

export var useSegmentPage = function useSegmentPage(name) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      category = _ref.category,
      properties = _objectWithoutProperties(_ref, ["category"]);

  var options = arguments.length > 2 ? arguments[2] : undefined;
  return useEffect(function () {
    if (!name) return;
    if (category) analytics.page(category, name, properties, options);else analytics.page(name, properties, options);
  }, [name]);
};